import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import { ProgressBar } from '@/routes/_embaUserLayout/-components/ProgressBar';
import { Link } from '@tanstack/react-router';
import classNames from 'classnames';
import type React from 'react';
import styles from './index.module.scss';

export const ENROLLMENT_COURSE_CARD = graphql(/* GraphQL */ `
  fragment EnrollmentCourseCard on UserEnrollmentCourse {
    id
    status
    statusText
    displayPeriod
    embaCourse {
      id
      name
      slug
      thumbnailImageUrl
    }
    latestAttendance {
      id
      slug
      attendedCountText
      progress
      status
    }
  }
`);

export type EnrollmentCourseCardProps = {
  course: FragmentType<typeof ENROLLMENT_COURSE_CARD>;
};

export const EnrollmentCourseCard: React.FC<EnrollmentCourseCardProps> = ({
  course,
}) => {
  const enrollmentCourse = useFragment(ENROLLMENT_COURSE_CARD, course);

  return (
    <li className={styles.enrollmentCourse}>
      <div className={styles.courseInfo}>
        <h3>
          {enrollmentCourse.status === 'completed' && (
            <span className={styles.completedStatusIcon}>
              {enrollmentCourse.statusText}
            </span>
          )}

          <p className={styles.courseTitle}>
            {enrollmentCourse.embaCourse.name}
          </p>
        </h3>
        <div className={styles.attendanceArea}>
          <span className={styles.courseImageArea}>
            <img src={enrollmentCourse.embaCourse.thumbnailImageUrl} alt="" />
          </span>
          <div className={styles.progress}>
            <p className={styles.attendedCount}>
              {enrollmentCourse.latestAttendance.attendedCountText}
            </p>
            <ProgressBar
              progress={enrollmentCourse.latestAttendance.progress}
            />
          </div>
        </div>
      </div>
      <div
        className={classNames(
          styles.linkArea,
          styles[enrollmentCourse.latestAttendance.status],
        )}
      >
        {enrollmentCourse.latestAttendance.status !== 'completed' && (
          <ul className={styles.linkList}>
            <li>
              <Link
                to="/enrollment-course/$enrollmentCourseId"
                params={{ enrollmentCourseId: enrollmentCourse.id }}
                className={styles.courseLink}
              >
                受講状況を見る
              </Link>
            </li>
          </ul>
        )}

        <div className={styles.lessonLinkArea}>
          {enrollmentCourse.latestAttendance.status === 'completed' ? (
            <div>
              <Link
                to="/enrollment-course/$enrollmentCourseId"
                params={{ enrollmentCourseId: enrollmentCourse.id }}
                className={styles.lessonLink}
              >
                受講状況を見る
              </Link>
            </div>
          ) : (
            <div>
              <Link
                to="/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug/redirect-recommended-content"
                params={{
                  enrollmentCourseId: enrollmentCourse.id,
                  attendanceSlug: enrollmentCourse.latestAttendance.slug,
                }}
                className={styles.lessonLink}
              >
                受講する
              </Link>
            </div>
          )}
          <div>
            <Link
              to="/enrollment-course/$enrollmentCourseId/attendance/$attendanceSlug"
              params={{
                enrollmentCourseId: enrollmentCourse.id,
                attendanceSlug: enrollmentCourse.latestAttendance.slug,
              }}
              className={styles.lessonAllLink}
            >
              レッスン一覧を見る
            </Link>
          </div>
        </div>
      </div>
    </li>
  );
};
